import { render } from "./DialogCanNotPurchaseAfterCanceled.vue?vue&type=template&id=640eb4bb"
import script from "./DialogCanNotPurchaseAfterCanceled.vue?vue&type=script&lang=js"
export * from "./DialogCanNotPurchaseAfterCanceled.vue?vue&type=script&lang=js"
script.render = render

export default script